import { render, staticRenderFns } from "./infoMeals.vue?vue&type=template&id=656db71e&"
import script from "./infoMeals.vue?vue&type=script&lang=js&"
export * from "./infoMeals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports